import dayjs from 'dayjs'
import { RequestBoxCompany } from 'src/models/RequestBox'
import { PromisedType } from 'src/utils/types'
import useSWR, { SWRConfiguration } from 'swr'
import { ApiClient, fetcher } from './client'
import {
  GET_REQUEST_BOXES,
  GET_SENT_REQUEST_BOXES,
  POST_INTERESTED as POST_ACCEPT_INTERESTED,
  POST_REJECT_REQUEST,
} from './endpoints'
import {
  AcceptInterestedRequest,
  RejectInterestedRequest,
  RequestBoxesResponse,
  RequestBoxResponse,
} from './types/requestBox'

const requestBoxFetcher = async (url: string, _: any) => {
  if (!url) return null
  const res = await ApiClient.get<{ requestBox: RequestBoxResponse }>(url)
  return res.data?.requestBox ? toRequestBox(res.data?.requestBox) : null
}

// FIXME: separate url from fetching messages.(/companies/messages/:id)
const GET_REQUEST_BOX_KEY = 'getRequestBox'
export const useRequestBox = (url: string) =>
  useSWR(!!url ? [url, GET_REQUEST_BOX_KEY] : null, requestBoxFetcher)

const toRequestBox = (data: RequestBoxResponse): RequestBoxCompany => ({
  id: data.id,
  companyId: data.companyId,
  replyCompanyId: data.replyCompanyId,
  status: data.status,
  requestReason: data.requestReason,
  requestReasonText: data.requestReasonText,
  requestAt: dayjs(data.requestAt),
  matchAt: dayjs(data.matchAt),
  schedule: data.schedule,
  imageUrl: data.imageUrl?.medium?.url || data.imageUrl?.url || '',
  name: data.name,
  adminName: data.adminName,
  matched: data.matched,
  introductoryText: {
    id: data.introductoryText?.id || 0,
    companyId: data.introductoryText?.companyId || 0,
    targetCompanyId: data.introductoryText?.targetCompanyId || 0,
    content: data.introductoryText?.content || '',
    createdAt: dayjs(data.introductoryText?.createdAt),
  },
})

export const acceptInterested = async (userId: number) => {
  const body: AcceptInterestedRequest = {
    request_box: {
      reply_company_id: userId,
    },
  }
  return ApiClient.post(POST_ACCEPT_INTERESTED, body)
}

export const rejectInterested = async (userId: number) => {
  const body: RejectInterestedRequest = {
    requested_company_id: userId,
  }
  return ApiClient.put(POST_REJECT_REQUEST, body)
}

export const useRequestBoxes = (config: Partial<SWRConfiguration> = {}) =>
  useSWR<PromisedType<typeof requestBoxesFetcher>>(
    `${GET_REQUEST_BOXES}`,
    requestBoxesFetcher,
    config,
  )

const requestBoxesFetcher = async (url: string) => {
  const res: RequestBoxesResponse = await fetcher(url)
  return {
    companies: res.companies.map(toRequestBox),
    requestedCount: res.requestedCount,
  }
}

export const useSentRequestBoxes = (config: Partial<SWRConfiguration> = {}) =>
  useSWR<PromisedType<typeof sentRequestBoxesFetcher>>(
    `${GET_SENT_REQUEST_BOXES}`,
    sentRequestBoxesFetcher,
    config,
  )

const sentRequestBoxesFetcher = async (url: string) => {
  const res: RequestBoxesResponse = await fetcher(url)
  return {
    companies: res.companies.map(toRequestBox),
  }
}
